// Using this module directly is deprecated. Use chainedRequest() or formRequest() instead.

import cookie from "cookie";
import responseHandler from "./responseHandler";

// We require superagent instead of importing it so that it can be replaced by supertest in unit tests.
let internalRequest = require("superagent");

// Add a xsrf token to the header which matches that cookie.
let setCsrfHeader = req => {
    if (typeof document !== "undefined") {
        let cookies = cookie.parse(document.cookie);
        if (cookies.csrf) {
            return req.set("X-CSRF-TOKEN", cookies.csrf);
        }
    }
    return req;
};

let addCommonHeaders = req => {
    // superagent doesn't set X-Requested-With header
    return req.set("X-Requested-With", "XMLHttpRequest");
};

let processRequest = req => {
    return setCsrfHeader(addCommonHeaders(req));
};

// Adds a .respond() method to the superagent chain which starts a responseHandler chain.
let createRespondMethod = (wrapper, req) => {
    // We only want respond() to be added if we are working in request(dispatcher) mode.
    if (wrapper.dispatcher) {
        req.respond = function() {
            return responseHandler(req, wrapper);
        };
    }
};

let defs = {
    get() {
        let req = internalRequest.get(...arguments);
        createRespondMethod(this, req);
        return processRequest(req);
    },

    post() {
        let req = internalRequest.post(...arguments);
        createRespondMethod(this, req);
        return processRequest(req);
    },

    del() {
        let req = internalRequest.del(...arguments);
        createRespondMethod(this, req);
        return processRequest(req);
    },

    __abort(req) {
        req.abort();
        this.aborted = true;
    },

    // For testing purposes, change the internal request mechanism.
    __setInternalRequest(req) {
        internalRequest = req;
    }
};

export default defs;